import { ROUTES } from '@/_navigation/routes';

import { CATEGORIES } from './category-mapper';

const bridgeData = [
  {
    [ROUTES.QUALIFY.link]: {
      backLabel: null,
      lightLogo: true,
      nextPage: ROUTES.MINDSET_Q1.link,

      main: true,
      hideBackButton: true,
      informative: true,

      header: `{name}, our Bridge Program helps you work towards  your RN in <div class="i">less time</div>.`,
      subheader: `Let’s see how it will work <div class="i">for you</div>.`,
      buttonText: 'Next',
      backgroundColor: 'bg-primary',
    },
    questions: [
      {
        [ROUTES.MINDSET_Q1.link]: {
          backLabel: 'QUESTION 1/12',
          isScoringQuestion: true,
          question: true,
          nextPage: ROUTES.MINDSET_Q2.link,
          api: 'Highest_Education_Level__c',
          scoreField: 'Mindset_Qualify_Score__c',
          header: `What’s the furthest you’ve gone in your education?`,
          buttonText: 'Next',
          backgroundColor: 'bg-primary-xx-light',
          disableButton: false,
          category: CATEGORIES.MINDSET_QUALIFY,
          list: [
            {
              input: 'select',
              options: [
                { option: `Still in high school`, score: 5 },
                { option: `High school diploma/GED`, score: 20 },
                { option: `Some college courses`, score: 20 },
                { option: `Associate degree`, score: 10 },
                { option: `Bachelor’s degree`, score: 0 },
              ],
            },
          ],
        },
      },
      {
        [ROUTES.MINDSET_Q2.link]: {
          backLabel: 'QUESTION 2/12',

          isScoringQuestion: true,
          question: true,
          nextPage: ROUTES.MINDSET_Q3.link,
          scoreField: 'Mindset_Qualify_Score__c',
          header: `Are you working in nursing, emergency, or patient care?`,
          buttonText: 'Next',
          backgroundColor: 'bg-primary-xx-light',
          disableButton: false,
          category: CATEGORIES.MINDSET_QUALIFY,
          api: 'Currently_Employed_Nrse_Emerg_Pt_Care__c',

          list: [
            {
              input: 'select',
              options: [
                {
                  option: `Yes, as an LPN`,
                  score: 25,
                },
                {
                  option: `Yes, in a related role`,
                  score: 20,
                },
                {
                  option: `No, not in healthcare`,
                  score: 15,
                },
                {
                  option: `No, not working`,
                  score: 5,
                },
              ],
            },
          ],
        },
      },
      {
        [ROUTES.MINDSET_Q3.link]: {
          backLabel: 'QUESTION 3/12',
          nextPage: ROUTES.MINDSET_INFO1.link,
          api: 'ATP_2__c', // OK
          scoreField: 'Mindset_Qualify_Score__c',
          header: `What part of your RN path has been frustrating?`,
          buttonText: 'Next',
          backgroundColor: 'bg-primary-xx-light',
          question: true,
          category: CATEGORIES.MINDSET_QUALIFY,
          list: [{ input: 'textarea' }],
        },
      },
      {
        [ROUTES.MINDSET_INFO1.link]: {
          backLabel: '',
          step: '',
          nextPage: ROUTES.MINDSET_Q4.link,
          informative: true,
          bubbleChat: true,
          header: '{name}, did you know...',
          subheader: `Traditional college has failed working adults. Inconvenient schedules and heavy work loads make it challenging for parents and nursing professionals to succeed. <div class="i">Our goal is to ease these barriers for you</div>.`,
          buttonText: 'Next',
          backgroundColor: 'bg-primary-xx-light',
        },
      },
      {
        [ROUTES.MINDSET_Q4.link]: {
          backLabel: 'QUESTION 4/12',
          isScoringQuestion: true,
          question: true,
          nextPage: ROUTES.MINDSET_INFO2.link,
          api: 'ATP_4__c',
          scoreField: 'Mindset_Qualify_Score__c',
          header: `How would you feel if you could <div class="i">save</div> time while passing college courses?`,
          buttonText: 'Next',
          backgroundColor: 'bg-primary-xx-light',
          allowCategoryAndUpload: true,
          category: CATEGORIES.MINDSET_QUALIFY,
          list: [
            {
              input: 'select',
              options: [
                { option: `I wouldn't care.`, score: 15 },
                { option: `Somewhat excited.`, score: 25 },
                { option: `Very excited.`, score: 50 },
              ],
            },
          ],
        },
      },
      {
        [ROUTES.MINDSET_INFO2.link]: {
          backLabel: '',
          step: '',
          nextPage: ROUTES.BRIDGE_START.link,
          informative: true,
          bubbleChat: true,
          header: `{name}, you've come to the right place! 😊`,
          subheader: `Achieve can help you reach your RN career goals, no matter where you're starting from. <div class="i">Let's see how our Bridge Program works.</div>`,
          buttonText: 'Next',
          backgroundColor: 'bg-primary-xx-light',
        },
      },
    ],
  },

  {
    [ROUTES.BRIDGE_START.link]: {
      backLabel: '',
      lightLogo: true,
      nextPage: ROUTES.BRIDGE_GEN_ED.link,
      informative: true,

      header: `{name}, we want to know where you’re at in your education journey.`,
      subheader: `Let's explore how we can help you save <div class="i">time</div> and <div class="i">effort</div> while passing your general education courses.`,
      buttonText: 'Next',

      backgroundColor: 'bg-primary',

      hideBackButton: true,
      main: true,
    },
    questions: [],
  },

  {
    [ROUTES.BRIDGE_GEN_ED.link]: {
      backLabel: 'Bridge 1/4',
      nextPage: ROUTES.BRIDGE_GEN_ED_INFO.link,
      informative: true,

      main: true,
      step: 'Bridge 1/4',
      header: 'General Education',
      subheader: `Accredited nursing colleges require several General Education (Gen Ed) or Prerequisite courses before you can start your core RN courses. <div class="i">Let’s take a look at these Gen Eds</div>.`,
      buttonText: 'Next',
      darklogo: true,
      backgroundColor: 'bg-primary-x-medium',
    },
    questions: [
      {
        [ROUTES.BRIDGE_GEN_ED_INFO.link]: {
          backLabel: '',
          nextPage: ROUTES.BRIDGE_GEN_ED_Q1.link,
          informative: true,
          step: '',
          disableButton: false,
          customBody: 'gen ed table',
          subheader: `RNs must complete their Gen Eds as part of the nursing degree process. We can help determine which of your previous college credits will transfer.`,
          buttonText: 'Next',
          backgroundColor: 'bg-primary-xx-light',
        },
      },
      {
        [ROUTES.BRIDGE_GEN_ED_Q1.link]: {
          backLabel: 'QUESTION 5/12',
          isScoringQuestion: true,
          question: true,
          nextPage: ROUTES.BRIDGE_GEN_ED_Q2.link,
          api: 'ATP_5__c', // OK
          scoreField: 'General_Education_Score__c',
          header: 'Have you passed any of your General Ed courses?',
          buttonText: 'Next',
          backgroundColor: 'bg-primary-xx-light',
          category: CATEGORIES.GENERAL_EDUCATION,
          list: [
            {
              input: 'select',
              options: [
                { option: `I've passed all of my Gen Ed Courses.`, score: 0 },
                { option: `I've passed some, but not all of them.`, score: 15 },
                { option: `I haven't passed any Gen Eds yet.`, score: 20 },
                { option: `I'm not certain what I've passed.`, score: 10 },
              ],
              conditionals: [
                {
                  value: `I've passed all of my Gen Ed Courses.`,
                  redirect: true,
                  skipQuestion: { api: 'ATP_6__c', value: 'Not important.' },
                  page: ROUTES.BRIDGE_GEN_ED_END_PASSED_END.link,
                },
              ],
            },
          ],
        },
      },
      {
        [ROUTES.BRIDGE_GEN_ED_Q2.link]: {
          backLabel: 'QUESTION 6/12',
          isScoringQuestion: true,
          question: true,
          nextPage: ROUTES.BRIDGE_GEN_ED_END.link,
          api: 'ATP_6__c', // OK
          scoreField: 'General_Education_Score__c',
          header: `How important is it to finish your remaining Gen Ed courses <div class="i"> in less time</div>?`,
          buttonText: 'Next',
          backgroundColor: 'bg-primary-xx-light',
          category: CATEGORIES.GENERAL_EDUCATION,
          list: [
            {
              input: 'select',
              options: [
                { option: `Not important.`, score: 10 },
                { option: `Somewhat important.`, score: 25 },
                { option: `Very important.`, score: 50 },
              ],
              conditionals: [{ value: 'Not important', redirect: true, page: '1_reject' }],
            },
          ],
        },
      },
      {
        [ROUTES.BRIDGE_GEN_ED_END.link]: {
          backLabel: '',
          nextPage: ROUTES.BRIDGE_ENTRANCE_EXAM.link,
          informative: true,
          bubbleChat: true,
          step: '',
          header: `Great, {name}! We can help. Let’s keep going...`,
          subheader: `Gen Ed credits typically take two years in traditional college, but our Bridge Plan can fast track your courses without compromising your schedule. <div class="i">Now, let’s take a look at your RN Entrance Exam</div>.`,
          buttonText: 'Next',
          backgroundColor: 'bg-primary-xx-light',
          allowCategoryAndUpload: true,
          category: CATEGORIES.GENERAL_EDUCATION,
        },
      },
      {
        [ROUTES.BRIDGE_GEN_ED_END_PASSED_END.link]: {
          backLabel: '',
          nextPage: ROUTES.BRIDGE_GEN_ED_END.link,
          informative: true,
          bubbleChat: true,
          step: '',
          header: `That's outstanding, {name}! Let's keep going...`,
          subheader: `Excellent job on passing all of your required Gen Ed courses - we know it's not easy. <div class="i">Now, let's move forward with the RN Entrance Exam...</div>`,
          buttonText: 'Next',
          backgroundColor: 'bg-primary-xx-light',
          allowCategoryAndUpload: true,
          category: CATEGORIES.GEN_ED_REPATH_PASSED_ALL,
        },
      },
    ],
  },

  {
    [ROUTES.BRIDGE_ENTRANCE_EXAM.link]: {
      backLabel: 'Bridge 2/4',
      nextPage: ROUTES.BRIDGE_ENTRANCE_EXAM_Q1.link,
      informative: true,

      main: true,
      header: 'RN Entrance Exam',
      step: 'Bridge 2/4',
      subheader: `Before you can get admitted to an accredited nursing school, you will be required to pass one of the RN Entrance Exams <span class="font-bold contents">(TEAS, HESI, PAX, KAPLAN)</span>. <div class="i">Let’s see what type of support you may need…</div>`,
      buttonText: 'Next',
      darklogo: true,
      backgroundColor: 'bg-primary-x-medium',
    },
    questions: [
      {
        [ROUTES.BRIDGE_ENTRANCE_EXAM_Q1.link]: {
          backLabel: 'QUESTION 7/12',
          isScoringQuestion: true,
          question: true,
          nextPage: ROUTES.BRIDGE_ENTRANCE_EXAM_INFO.link,
          api: 'ATP_7__c', // OK
          scoreField: 'Entrance_Exam_Score__c',
          header: 'Have you taken and passed your RN Entrance Exam?',
          buttonText: 'Next',
          backgroundColor: 'bg-primary-xx-light',
          category: CATEGORIES.ENTRANCE_EXAM,
          list: [
            {
              input: 'select',
              options: [
                { option: `I’ve passed my RN entrance exam.`, score: 0 },
                { option: `I took the exam, but didn't pass.`, score: 50 },
                { option: `I haven’t taken my RN entrance exam.`, score: 50 },
              ],
              conditionals: [
                {
                  value: `I’ve passed my RN entrance exam.`,
                  redirect: true,
                  skipQuestion: { api: 'ATP_8__c', value: 'Not concerned.' },
                  page: ROUTES.BRIDGE_ENTRANCE_EXAM_PASSED_END.link,
                },
              ],
            },
          ],
        },
      },
      {
        [ROUTES.BRIDGE_ENTRANCE_EXAM_INFO.link]: {
          backLabel: '',
          nextPage: ROUTES.BRIDGE_ENTRANCE_EXAM_Q2.link,
          informative: true,
          bubbleChat: true,
          step: '',
          header: `{name}, Achieve offers Entrance Exam support.`,
          subheader: `Each nursing college sets their own requirements on how many times you can take an RN Entrance Exam, with additional restrictions on how long you have to wait in between each attempt. <div class="i">How would you like to avoid delays and pass on the first attempt</div>?`,
          buttonText: 'Next',
          backgroundColor: 'bg-primary-xx-light',
        },
      },
      {
        [ROUTES.BRIDGE_ENTRANCE_EXAM_Q2.link]: {
          backLabel: 'QUESTION 8/12',
          isScoringQuestion: true,
          question: true,
          nextPage: ROUTES.BRIDGE_ENTRANCE_EXAM_END.link,
          api: 'ATP_8__c', // OK
          scoreField: 'Entrance_Exam_Score__c',
          header: 'How concerned are you about your ability to pass your RN Entrance Exam?',
          buttonText: 'Next',
          backgroundColor: 'bg-primary-xx-light',
          category: CATEGORIES.ENTRANCE_EXAM,
          list: [
            {
              input: 'select',
              options: [
                { option: `Not concerned.`, score: 10 },
                { option: `Somewhat concerned.`, score: 25 },
                { option: `Very concerned.`, score: 50 },
              ],
            },
          ],
        },
      },
      {
        [ROUTES.BRIDGE_ENTRANCE_EXAM_END.link]: {
          backLabel: '',
          nextPage: ROUTES.BRIDGE_CORE_NURSING.link,
          informative: true,
          bubbleChat: true,
          step: '',
          header: `{name}, we can help you reach this goal.`,
          subheader: `93% of Achieve customers pass their RN Entrance Exam on the first try. After Gen Eds and the RN Entrance Exam, your core RN courses are next. <br/><div class="i">Let’s see what type of support you may need for your core RN courses...</div>`,
          buttonText: 'Next',
          backgroundColor: 'bg-primary-xx-light',
          allowCategoryAndUpload: true,
          category: CATEGORIES.ENTRANCE_EXAM,
        },
      },
      {
        [ROUTES.BRIDGE_ENTRANCE_EXAM_PASSED_END.link]: {
          backLabel: '',
          nextPage: ROUTES.BRIDGE_ENTRANCE_EXAM_END.link,
          informative: true,
          bubbleChat: true,
          step: 'Bridge 2/4',
          header: `Way to go, {name}! Let's move forward...`,
          subheader: `Now, let’s see what type of guidance and support you may need for your core RN courses.`,
          buttonText: 'Next',
          backgroundColor: 'bg-primary-xx-light',
          allowCategoryAndUpload: true,
          category: CATEGORIES.REPATH_PASSED_ENTRANCE_EXAM,
        },
      },
    ],
  },

  {
    [ROUTES.BRIDGE_CORE_NURSING.link]: {
      backLabel: 'Bridge 3/4',
      nextPage: ROUTES.BRIDGE_CORE_NURSING_Q1.link,
      informative: true,
      main: true,

      header: CATEGORIES.CORE_RN_COURSES,
      step: 'Bridge 3/4',
      subheader: `We offer support throughout your education journey, including core RN courses taken through your accredited college or university of choice.`,
      buttonText: 'Next',
      darklogo: true,
      backgroundColor: 'bg-primary-x-medium',
    },
    questions: [
      {
        [ROUTES.BRIDGE_CORE_NURSING_Q1.link]: {
          backLabel: 'QUESTION 9/12',
          isScoringQuestion: true,
          question: true,
          nextPage: ROUTES.BRIDGE_CORE_NURSING_Q2.link,
          api: 'ATP_9__c', // OK
          scoreField: 'Core_Nursing_Courses_Score__c',
          header: 'Have you taken and passed your core RN courses?',
          buttonText: 'Next',
          backgroundColor: 'bg-primary-xx-light',
          category: CATEGORIES.CORE_RN_COURSES,
          list: [
            {
              input: 'select',
              options: [
                { option: `I’ve passed my core RN courses.`, score: 0 },
                { option: `I've passed some, but not all of them.`, score: 25 },
                { option: `I haven’t taken my core RN courses.`, score: 50 },
              ],
              conditionals: [
                {
                  value: `I’ve passed my core RN courses.`,
                  redirect: true,
                  skipQuestion: { api: 'ATP_10__c', value: 'Not concerned.' },
                  page: ROUTES.BRIDGE_CORE_NURSING_PASSED_END.link,
                },
              ],
            },
          ],
        },
      },

      {
        [ROUTES.BRIDGE_CORE_NURSING_Q2.link]: {
          backLabel: 'QUESTION 10/12',
          isScoringQuestion: true,
          question: true,
          nextPage: ROUTES.BRIDGE_CORE_NURSING_END.link,
          api: 'ATP_10__c', // OK
          scoreField: 'Core_Nursing_Courses_Score__c',
          header: 'How concerned are you about your ability to pass each core RN course?',
          buttonText: 'Next',
          backgroundColor: 'bg-primary-xx-light',
          category: CATEGORIES.CORE_RN_COURSES,
          list: [
            {
              input: 'select',
              options: [
                { option: `Not concerned.`, score: 10 },
                { option: `Somewhat concerned.`, score: 25 },
                { option: `Very concerned.`, score: 50 },
              ],
            },
          ],
        },
      },
      {
        [ROUTES.BRIDGE_CORE_NURSING_END.link]: {
          backLabel: '',
          nextPage: ROUTES.BRIDGE_EXIT_EXAM.link,
          informative: true,
          bubbleChat: true,
          step: '',
          header: `Guidance at every step.`,
          subheader: `As you take your core RN courses through your accredited college, we offer tutoring support and guidance from experienced BSNs.Now, let’s see how much support you need with the final step, the NCLEX-RN.`,
          buttonText: 'Next',
          allowCategoryAndUpload: true,
          category: CATEGORIES.CORE_RN_COURSES,
          backgroundColor: 'bg-primary-xx-light',
        },
      },
      {
        [ROUTES.BRIDGE_CORE_NURSING_PASSED_END.link]: {
          backLabel: '',
          nextPage: ROUTES.BRIDGE_CORE_NURSING_END.link,
          informative: true,
          bubbleChat: true,
          step: 'Bridge 3/4',
          header: `Great work, {name}! And now, the final step...`,
          subheader: `Let’s see how much support you need with the final step of the Bridge, your RN Licensure Exam (NCLEX-RN).`,
          buttonText: 'Next',
          allowCategoryAndUpload: true,
          category: CATEGORIES.REPATH_PASSED_CORE_RN_COURSES,
          backgroundColor: 'bg-primary-xx-light',
        },
      },
    ],
  },

  {
    [ROUTES.BRIDGE_EXIT_EXAM.link]: {
      backLabel: 'Bridge 4/4',
      nextPage: ROUTES.BRIDGE_EXIT_EXAM_Q1.link,
      informative: true,
      main: true,

      step: 'Bridge 4/4',
      header: 'NCLEX-RN Exam',
      subheader: `The NCLEX-RN is the all-important step between graduating from nursing school and becoming an RN. It’s a standardized test, set by the Board of Nursing in each state, that makes sure you have the knowledge and skills you need to be a Registered Nurse.`,
      buttonText: 'Next',
      darklogo: true,
      backgroundColor: 'bg-primary-x-medium',
    },
    questions: [
      {
        [ROUTES.BRIDGE_EXIT_EXAM_Q1.link]: {
          backLabel: 'QUESTION 11/12',
          isScoringQuestion: true,
          question: true,
          nextPage: ROUTES.BRIDGE_EXIT_EXAM_Q2.link,
          api: 'ATP_11__c', // OK
          scoreField: 'Exit_Exam_Score__c',
          header: 'Have you taken and passed your NCLEX-RN Exam?',
          buttonText: 'Next',
          backgroundColor: 'bg-primary-xx-light',
          category: CATEGORIES.EXIT_EXAM,
          list: [
            {
              input: 'select',
              options: [
                { option: `I’ve passed the NCLEX-RN.`, score: 0 },
                { option: `I took the NCLEX-RN, but didn’t pass it.`, score: 50 },
                { option: `I haven’t taken the NCLEX-RN yet.`, score: 50 },
              ],
              conditionals: [
                {
                  value: `I’ve passed the NCLEX-RN.`,
                  redirect: true,
                  skipQuestion: { api: 'ATP_12__c', value: 'Not concerned.' },
                  page: ROUTES.BRIDGE_EXIT_EXAM_PASSED_END.link,
                },
              ],
            },
          ],
        },
      },
      {
        [ROUTES.BRIDGE_EXIT_EXAM_INFO.link]: {
          backLabel: '',
          nextPage: ROUTES.BRIDGE_EXIT_EXAM_END.link,
          informative: true,
          bubbleChat: true,
          step: '',
          header: `Cross the finish line with confidence.`,
          subheader: `The NCLEX-RN has between 75 to 145 questions, stopping when your competency level has been identified. Passing the exam on your first attempt will bypass any delays (up to 45 days to retest) in getting you that RN pay.`,
          buttonText: 'Next',
          backgroundColor: 'bg-primary-xx-light',
        },
      },
      {
        [ROUTES.BRIDGE_EXIT_EXAM_Q2.link]: {
          backLabel: 'QUESTION 12/12',
          isScoringQuestion: true,
          question: true,
          nextPage: ROUTES.BRIDGE_EXIT_EXAM_INFO.link,
          api: 'ATP_12__c', // OK
          scoreField: 'Exit_Exam_Score__c',
          header: 'How concerned are you about your ability to pass your NCLEX-RN Exam?',
          buttonText: 'Next',
          backgroundColor: 'bg-primary-xx-light',
          category: CATEGORIES.EXIT_EXAM,
          list: [
            {
              input: 'select',
              options: [
                { option: `Not concerned.`, score: 10 },
                { option: `Somewhat concerned.`, score: 25 },
                { option: `Very concerned.`, score: 50 },
              ],
            },
          ],
        },
      },
      {
        [ROUTES.BRIDGE_EXIT_EXAM_END.link]: {
          backLabel: '',
          nextPage: ROUTES.BRIDGE_CONFIRM_CONTACT.link,
          informative: true,
          bubbleChat: true,
          step: '',
          header: `{name}, we can help. Let’s do this together.`,
          subheader: `The first step is to customize your Bridge Plan, a step-by-step map outlining everything you need for your education journey. <div class="i">Now that we know more about you, let’s move forward and see where Achieve can help...</div>`,
          buttonText: 'Next',
          allowCategoryAndUpload: true,
          category: CATEGORIES.EXIT_EXAM,
          backgroundColor: 'bg-primary-xx-light',
        },
      },
      {
        [ROUTES.BRIDGE_EXIT_EXAM_PASSED_END.link]: {
          backLabel: '',
          nextPage: ROUTES.BRIDGE_EXIT_EXAM_PASSED_END_Q1.link,
          informative: true,
          bubbleChat: true,
          step: '',
          header: `{name}, congrats! You should be proud...`,
          subheader: `Once your scores are official they will be published on your state's Board of Nursing website and you can legally practice as a nurse in your state. We wish you the best with your exciting job hunt. Please share Achieve with your nursing friends and family.`,
          buttonText: 'Next',
          backgroundColor: 'bg-primary-xx-light',
          allowCategoryAndUpload: true,
          category: CATEGORIES.REPATH_PASSED_EXIT_EXAM,
          hideProgress: true,
        },
      },
      {
        [ROUTES.BRIDGE_EXIT_EXAM_PASSED_END_Q1.link]: {
          backLabel: 'QUESTION 12/12',
          nextPage: ROUTES.BRIDGE_EXIT_EXAM_PASSED_END_Q1_END.link,
          api: 'ATP_Exit_Reject__c',
          bubbleChat: true,
          header: '{name}, can you share what you are looking to learn?',
          buttonText: 'Next',
          backgroundColor: 'bg-primary-xx-light',
          question: true,
          hideProgress: true,
          allowCategoryAndUpload: true,
          list: [{ input: 'textarea' }],
        },
      },
      {
        [ROUTES.BRIDGE_EXIT_EXAM_PASSED_END_Q1_END.link]: {
          backLabel: '',
          nextPage: '',
          informative: true,
          bubbleChat: true,
          customKey: 'rejectInfo',
          header: `{name}, thanks for helping us understand.`,
          subheader: `Please keep Achieve Test Prep in mind if you have nursing friends and family interested in pursuing their RN program with less stress and time.`,
          info: `Want to see your NCLEX results and see what you should expect in the following weeks?`,
          infoLink: 'https://www.nclex.com/quick-results.page',
          fullHeight: true,
          hideFooter: true,
          buttonText: 'Next',
          backgroundColor: 'bg-primary-xx-light',
        },
      },
      {
        [ROUTES.BRIDGE_CONFIRM_CONTACT.link]: {
          backLabel: '',
          nextPage: ROUTES.BRIDGE_RESULTS.link,
          api: 'contact_form',
          step: '',
          header: 'Confirm your contact info to get started.',
          buttonText: 'Next',
          isSubmission: true,
          backgroundColor: 'bg-primary-xx-light',
          category: CATEGORIES.RESULT_QUALIFY,
          list: [{ input: 'contact_form' }],
        },
      },
      {
        [ROUTES.BRIDGE_RESULTS.link]: {
          backLabel: '',
          nextPage: ROUTES.BRIDGE_PLAN_NEXT_STEP.link,
          informative: true,
          question: false,
          results: true,
          darklogo: true,
          header: `You’re qualified to get a College Bridge Plan!`,
          hideProgress: true,
          subheader: `Your College Bridge Plan will explain how to accelerate your path to your RN.`,
          buttonText: 'Next',
          backgroundColor: 'bg-white',
          boxShadowColor: '1px 1px 7px 3px rgba(209, 148, 217, 0.2)',
          buttonColor: 'bg-primary',
          footerColor: 'bg-white',
          category: CATEGORIES.RESULT_QUALIFY,
        },
      },
      {
        [ROUTES.BRIDGE_PLAN_NEXT_STEP.link]: {
          backLabel: '',
          nextPage: ROUTES.BRIDGE_PLAN_ADVISOR_PLAN.link,
          pageCard: true,
          customKey: 'planFinishFaster',
          fullHeight: true,
          buttonText: 'Next',
          hideButtonIcon: false,
          hideFooter: true,
          backgroundColor: 'bg-primary-xx-light',
          buttonColor: 'bg-primary',
        },
      },

      {
        [ROUTES.BRIDGE_PLAN_ADVISOR_PLAN.link]: {
          backLabel: '',
          nextPage: ROUTES.BRIDGE_PLAN_WHY_PLAN.link,
          pageCard: true,
          customKey: 'youAndYourAdvisor',
          fullHeight: true,
          buttonText: 'Next',
          hideButtonIcon: false,
          hideFooter: true,
          backgroundColor: 'bg-primary-xx-light',
          buttonColor: 'bg-primary',
        },
      },
      {
        [ROUTES.BRIDGE_PLAN_WHY_PLAN.link]: {
          backLabel: '',
          nextPage: ROUTES.BRIDGE_PLAN_PRE_BUY.link,
          pageCard: true,
          customKey: 'whyShouldBridge',
          fullHeight: true,
          buttonText: 'Next',
          hideButtonIcon: false,
          hideFooter: true,
          backgroundColor: 'bg-primary-xx-light',
          buttonColor: 'bg-primary',
          category: CATEGORIES.BP_INFO,
        },
      },
      {
        [ROUTES.BRIDGE_PLAN_PRE_BUY.link]: {
          backLabel: '',
          nextPage: ROUTES.BRIDGE_PLAN_PRE_BUY_CHECKOUT.link,
          pageCard: true,
          customKey: 'prebuyyourbridge',
          fullHeight: true,
          buttonText: 'Start My Plan',
          hideButtonIcon: true,
          hideFooter: true,
          backgroundColor: 'bg-primary-xx-light',
          buttonColor: 'bg-primary',
          category: CATEGORIES.BP_PRE_BUY,
        },
      },
      /** New Question Page */
      {
        [ROUTES.BRIDGE_PLAN_WO_PRE_BUY_READY.link]: {
          backLabel: '',
          nextPage: '',
          api: 'MQL_Readiness__c',
          scoreField: 'Readiness_Score__c',
          isScoringQuestion: true,
          question: true,
          customKey: 'WhenToMeet',
          hideProgress: true,
          header: 'When would you like to get started?',
          buttonText: 'Next',
          backgroundColor: 'bg-primary-xx-light',
          hideButton: false,
          meetAction: true,
          allowCategoryAndUpload: true,
          category: CATEGORIES.READINESS,
          list: [
            {
              input: 'select',
              options: [
                { option: 'ASAP', answerTestKey: 'ASAP', score: 15 },
                { option: 'Within 3 months', answerTestKey: 'Within 3 months', score: 15 },
                { option: '3-6 months', answerTestKey: '3-6 months', score: 10 },
                { option: '6+ months', answerTestKey: '6+ months', score: 5 },
              ],
              conditionals: [
                { page: ROUTES.BRIDGE_PLAN_WO_PRE_BUY_READY_ASAP.link, redirect: true, value: 'ASAP' },
                { page: ROUTES.BRIDGE_PLAN_WO_PRE_BUY_READY_1_3_MONTHS.link, redirect: true, value: 'Within 3 months' },
                { page: ROUTES.BRIDGE_PLAN_WO_PRE_BUY_READY_3_6_MONTHS.link, redirect: true, value: '3-6 months' },
                { page: ROUTES.BRIDGE_PLAN_WO_PRE_BUY_READY_6_MONTHS.link, redirect: true, value: '6+ months' },
              ],
            },
          ],
        },
      },

      /** ASAP */
      {
        [ROUTES.BRIDGE_PLAN_WO_PRE_BUY_READY_ASAP.link]: {
          backLabel: '',
          nextPage: '',
          api: 'Readiness_Option_1__c', // OK
          scoreField: 'Readiness_Score__c',
          isScoringQuestion: true,
          question: true,
          customKey: 'WhenToMeetASAP',
          hideProgress: true,
          header: 'How would you like to connect with an advisor?*',
          subheader:
            '​​Every great career journey starts with the right guidance. Connect with an Education Advisor to start shaping your personalized career plan.',
          buttonText: 'Next',
          backgroundColor: 'bg-primary-xx-light',
          hideButton: false,

          category: CATEGORIES.READINESS,
          list: [
            {
              input: 'select',
              options: [
                // { option: 'Start a meeting now', answerTestKey: 'Start a meeting now', score: 20 },
                { option: 'Schedule a meeting', answerTestKey: 'Schedule a meeting', score: 10 },
                { option: 'Start a live chat', answerTestKey: 'Start a live chat', score: 10 },
              ],
              conditionals: [
                // { action: 'HAVE_A_MEETING', value: 'Start a meeting now', page: ROUTES.REDIRECT_TO_MEET_NOW.onlyLink },
                {
                  action: 'SCHEDULE_MEETING',
                  value: 'Schedule a meeting',
                  page: ROUTES.BRIDGE_PLAN_WO_PRE_BUY_READY_ASAP_SCHEDULED.link,
                },
                { action: 'LAUNCH_CHAT', value: 'Start a live chat' },
              ],
            },
          ],
        },
      },

      {
        [ROUTES.BRIDGE_PLAN_WO_PRE_BUY_READY_ASAP_SCHEDULED.link]: {
          backLabel: '',
          informative: true,
          bubbleChat: true,
          hideProgress: true,
          fullHeight: true,
          calendlyComponent: true,
          hideFooter: true,
          step: '',
          buttonText: 'Next',
          backgroundColor: 'bg-primary-x-medium',
          disableButton: true,
          allowCategoryAndUpload: true,
          category: CATEGORIES.READINESS_APPT_CONFIRMED,
          nextCategory: CATEGORIES.READINESS_APPT_CONFIRMED,
        },
        questions: [],
      },

      /** 1-3 months */
      {
        [ROUTES.BRIDGE_PLAN_WO_PRE_BUY_READY_1_3_MONTHS.link]: {
          backLabel: '',
          nextPage: '',
          api: 'Readiness_Option_2__c',
          scoreField: 'Readiness_Score__c',
          isScoringQuestion: true,
          question: true,
          customKey: 'WhenToMeet13Months',
          hideProgress: true,
          header: ' How would you like to connect with an advisor?*',
          subheader:
            'Every great career journey starts with the right guidance. Connect with an Education Advisor to start shaping your personalized career plan.',
          buttonText: 'Next',
          backgroundColor: 'bg-primary-xx-light',
          hideButton: false,

          category: CATEGORIES.READINESS,
          list: [
            {
              input: 'select',
              options: [
                // { option: 'Start a meeting now', answerTestKey: 'Start a meeting now', score: 20 },
                { option: 'Schedule a meeting', answerTestKey: 'Schedule a meeting', score: 10 },
                { option: 'Start a live chat', answerTestKey: 'Start a live chat', score: 10 },
              ],
              conditionals: [
                // { action: 'HAVE_A_MEETING', value: 'Start a meeting now', page: ROUTES.REDIRECT_TO_MEET_NOW.onlyLink },
                {
                  action: 'SCHEDULE_MEETING',
                  value: 'Schedule a meeting',
                  page: ROUTES.BRIDGE_PLAN_WO_PRE_BUY_READY_1_3_MONTHS_SCHEDULED.link,
                },
                { action: 'LAUNCH_CHAT', value: 'Start a live chat' },
              ],
            },
          ],
        },
      },

      {
        [ROUTES.BRIDGE_PLAN_WO_PRE_BUY_READY_1_3_MONTHS_SCHEDULED.link]: {
          backLabel: '',
          informative: true,
          bubbleChat: true,
          hideProgress: true,
          fullHeight: true,
          calendlyComponent: true,
          hideFooter: true,
          step: '',
          buttonText: 'Next',
          backgroundColor: 'bg-primary-x-medium',
          disableButton: true,
          allowCategoryAndUpload: true,
          category: CATEGORIES.READINESS_APPT_CONFIRMED,
          nextCategory: CATEGORIES.READINESS_APPT_CONFIRMED,
        },
        questions: [],
      },

      /** 3-6 months */
      {
        [ROUTES.BRIDGE_PLAN_WO_PRE_BUY_READY_3_6_MONTHS.link]: {
          backLabel: '',
          nextPage: '',
          api: 'Readiness_Option_3__c',
          scoreField: 'Readiness_Score__c',
          isScoringQuestion: true,
          question: true,
          customKey: 'WhenToMeet36Months',
          hideProgress: true,
          header: ' Planning is the smartest step you can take.*',
          subheader:
            '​Connect with an Education Coordinator–we’ll show you how to prepare now so you’re confident and ready when it’s time to start.',
          buttonText: 'Next',
          backgroundColor: 'bg-primary-xx-light',
          hideButton: false,

          category: CATEGORIES.READINESS,
          list: [
            {
              input: 'select',
              options: [
                { option: 'Call (888) 350-7370', answerTestKey: 'Call (888) 350-7370', score: 10 },
                { option: 'Fast Track College Courses', answerTestKey: 'Fast Track College Courses', score: 5 },
                { option: 'ADN Career Options', answerTestKey: 'ADN Career Options', score: 5 },
              ],
              conditionals: [
                { action: 'HAVE_A_CALL', value: 'Call (888) 350-7370' },
                {
                  action: 'LINK',
                  value: 'Fast Track College Courses',
                  externalLink: 'https://www.achievetestprep.com/blog/top-5-ways-to-test-out-of-college-credits',
                },
                {
                  action: 'LINK',
                  value: 'ADN Career Options',
                  externalLink:
                    'https://www.achievetestprep.com/blog/what-can-you-do-with-an-associate-degree-in-nursing',
                },
              ],
            },
          ],
        },
      },

      /** 6+ months */
      {
        [ROUTES.BRIDGE_PLAN_WO_PRE_BUY_READY_6_MONTHS.link]: {
          backLabel: '',
          nextPage: '',
          api: 'Readiness_Option_4__c',
          scoreField: 'Readiness_Score__c',
          isScoringQuestion: true,
          question: true,
          customKey: 'WhenToMeet6Months',
          hideProgress: true,
          header: 'Not ready to start yet?',
          subheader: '​​Here are a few ways you can explore and learn until you’re ready to take the next step.',
          buttonText: 'Next',
          backgroundColor: 'bg-primary-xx-light',
          hideButton: false,

          category: CATEGORIES.READINESS,
          list: [
            {
              input: 'select',
              options: [
                { option: 'ADN Career Options', answerTestKey: 'ADN Career Options', score: 5 },
                { option: "Betsy's LPN to RN Story", answerTestKey: "Betsy's LPN to RN Story", score: 5 },
                { option: 'Faster with Credit-by-Exam', answerTestKey: 'Faster with Credit-by-Exam', score: 5 },
              ],
              conditionals: [
                {
                  action: 'LINK',
                  value: 'ADN Career Options',
                  externalLink:
                    'https://www.achievetestprep.com/blog/what-can-you-do-with-an-associate-degree-in-nursing',
                },
                {
                  action: 'LINK',
                  value: "Betsy's LPN to RN Story",
                  externalLink: 'https://www.achievetestprep.com/blog/achieve-test-prep-reviews-lpn-to-rn-bridge-erin',
                },
                {
                  action: 'LINK',
                  value: 'Faster with Credit-by-Exam',
                  externalLink: 'https://www.achievetestprep.com/blog/unschool-college-credit-by-exam',
                },
              ],
            },
          ],
        },
      },

      /** Not sure yet */
      // {
      //   [ROUTES.BRIDGE_PLAN_WO_PRE_BUY_READY_NOT_SURE.link]: {
      //     backLabel: '',
      //     nextPage: '',
      //     api: 'Readiness_Option_5__c',
      //     scoreField: 'Readiness_Score__c',
      //     isScoringQuestion: true,
      //     question: true,
      //     customKey: 'WhenToMeetNotSure',
      //     hideProgress: true,
      //     header: 'Not ready? No worries. Here’s your next step.',
      //     subheader: 'Keep learning at your own pace and confirm eligibility when you’re ready.',
      //     buttonText: 'Next',
      //     backgroundColor: 'bg-primary-xx-light',
      //     hideButton: false,

      //     category: CATEGORIES.READINESS,
      //     list: [
      //       {
      //         input: 'select',
      //         options: [
      //           { option: 'How to test out of courses', answerTestKey: 'How to test out of courses', score: 10 },
      //           { option: 'Explore student stories', answerTestKey: 'Explore student stories', score: 10 },
      //           { option: 'Start a live chat', answerTestKey: 'Start a live chat', score: 15 },
      //         ],
      //         conditionals: [
      //           {
      //             action: 'LINK',
      //             value: 'How to test out of courses',
      //             externalLink: 'https://www.achievetestprep.com/blog/can-you-test-out-of-college-courses',
      //           },
      //           {
      //             action: 'LINK',
      //             value: 'Explore student stories',
      //             externalLink: 'https://www.achievetestprep.com/testimonials',
      //           },
      //           { action: 'LAUNCH_CHAT', value: 'Start a live chat' },
      //         ],
      //       },
      //     ],
      //   },
      // },

      /** New Question Page */
      {
        [ROUTES.BRIDGE_PLAN_PRE_BUY_CHECKOUT.link]: {
          backLabel: '',
          informative: true,
          checkout: true,
          fullHeight: true,
          hideFooter: true,
          header: `Checkout`,
          buttonText: 'Pay Now',
          hideButtonIcon: true,
          backgroundColor: 'bg-primary-xx-light',
          buttonColor: 'bg-primary',
        },
      },
    ],
  },

  {
    [ROUTES.BRIDGE_PLAN_PRE_BUY_PURCHASED.link]: {
      backLabel: '',
      lightLogo: true,
      nextPage: ROUTES.BRIDGE_PLAN_PRE_BUY_RES.link,
      informative: true,
      header: `Congrats, {name}!<br/>You’ve taken the first step toward building an RN Bridge Plan that <div class="i">fits your life</div>.`,
      step: 'Congrats',
      buttonText: 'Next',
      backgroundColor: 'bg-primary',
      buttonColor: 'bg-primary',
      footerColor: 'bg-white',
      hideBackButton: true,
      main: true,
      hideProgress: true,
    },
    questions: [],
  },

  {
    [ROUTES.BRIDGE_PLAN_PRE_BUY_RES.link]: {
      backLabel: '',
      api: 'ATP_14__c',
      question: true,

      pageCard: true,
      customKey: 'bpPreBuyReservation',
      fullHeight: true,

      buttonText: 'Start a live chat',
      hideButtonIcon: false,

      hideFooter: true,
      backgroundColor: 'bg-primary-xx-light',
      buttonColor: 'bg-primary',
      meetAction: true,
      category: CATEGORIES.BP_PRE_BUY_RES_MEET,
      secondaryCategory: CATEGORIES.BP_PRE_BUY_RES_SCHEDULE,
      secondaryCategoryOfHours: CATEGORIES.BP_PRE_BUY_LEARN,

      isTimeSensitive: true,
      list: [
        {
          input: 'select',
          options: [
            { option: `I prefer to meet with an advisor now.`, score: 10, category: CATEGORIES.BP_PRE_BUY_RES_MEET },
            {
              option: `I prefer to schedule at another time.`,
              score: 10,
              category: CATEGORIES.BP_PRE_BUY_RES_SCHEDULE,
            },
          ],
        },
      ],
    },
    questions: [],
  },
  {
    [ROUTES.BRIDGE_PLAN_PRE_BUY_RES_SCHEDULED.link]: {
      backLabel: '',
      informative: true,
      bubbleChat: true,

      hideProgress: true,
      fullHeight: true,
      calendlyComponent: true,
      hideFooter: true,
      step: '',

      buttonText: 'Next',
      backgroundColor: 'bg-primary-x-medium',
      disableButton: true,
      allowCategoryAndUpload: true,

      category: CATEGORIES.BP_PRE_BUY_RES_CONFIRMED,
      nextCategory: CATEGORIES.BP_PRE_BUY_RES_CONFIRMED,
    },
    questions: [],
  },
];

export default bridgeData;

// window.bridgeData = bridgeData;
